import React, { useState, useEffect } from 'react';
import "./style.css";
import Base from '../../Components/Layout/Base';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategory } from '../../Redux/Actions/ProfileSteps';
import { useNavigate } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { ACTIVE_PAGE } from '../../Redux/Actions/types';
const ScreeningCriteria = () => { 
    const dispatch = useDispatch();
    const navitage  = useNavigate()
      const activePage = useSelector(s => s.jobBoard.activePage);
    
    const [selectedCategory, setSelectedCategory] = useState("all");
    const categoryList = useSelector(s => s.ProfileSteps.categoryList);
    
    useEffect(() => {
        dispatch(fetchCategory({ category_id: 0 }))
    }, [])
    
    
    const handleSelect = (e) => {
        const value = e.target.value;
        setSelectedCategory(value);
        if (value !== "all") {
            dispatch(fetchCategory({ category_id: value }))
        } else {
            dispatch(fetchCategory({ category_id: 0 }))
        }
    }
      const setThePage = page => {
        dispatch({
          type: ACTIVE_PAGE,
          payload: page
        });
      }
      const handlePageChange = (pageNumber) => {
        const page = pageNumber - 1;
        setThePage(page);
        dispatch(fetchCategory({ pageNo: page, pageSize: 10,category_id: selectedCategory === "all" ? 0 : selectedCategory }) );
      };
    return (
        <Base>
            <section className='pt-lg-5'>
                <div className="container">
                    <div className="">
                        <div className="content-box px-0 skill-showcase">
                            <h2 className="mb-3 mb-lg-4 text-dark">Screening Criteria :</h2>
                            <p className="col-md-7">
                                Choose a skill from the dropdown to upload a video in the respective category and get graded!
                            </p>
                            <p className='mt-4'>
                                Note : Flagged subcategory means video submission already done
                            </p>
                        </div>
                        <div className='content-box mb-3 py-3 d-flex justify-content-between align-items-center col-md-8 bg-yellow-gr'>
                            <img src="./images/layer.png" alt="" className='me-2' />
                            <p className='m-0 text-black fw-normal'>Don't leave them guessing. Add a new video clip to maximize your visibility.</p>
                        </div>
                        <div className='d-flex justify-content-between align-items-end screening-dropdown-sec'>
                            <div className='flex-fill me-2'>
                                <select 
                                    name="" 
                                    id="" 
                                    value={selectedCategory}
                                    onChange={(e) => handleSelect(e)} 
                                    className="screening-dropdown"
                                >
                                    <option value="all">All</option>
                                    {categoryList?.category_list?.map(category => (
                                        <option key={category.object_id} value={category.object_id}>
                                            {category.object_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='pt-4 pt-lg-5'>
                            {categoryList?.activity_list?.map((activity, idx) => (
                                <React.Fragment key={idx}>
                                    <div className='intro-video-item'>
                                        {/* <div className='col-12 col-md-7 ms-0 ms-md-4'> */}
                                        <div className=' ms-0 ms-md-4' onClick={() => navitage("/screening-details",{state:{activity}})}>
                                            <span className='fs-4 fw-bold'>{activity?.category_name}</span>
                                            <div className='d-flex'>
                                                <div className='video-icon'>
                                                    <img src="./svg/sell.svg" alt="video" />
                                                </div>
                                                <div className='video-details d-flex align-items-center justify-content-between'>
                                                    <h3>{activity.activity_name}</h3>
                                                </div>
                                            </div>
                                            <p>{activity?.activity_objective}</p>
                                        </div>
                                        {/* <div className='ps-5'>
                                            <button type='button' className='default-btn px-5 blue-bg border-0 ms-3 ms-lg-0 d-none d-lg-block'>
                                                Proceed with video submission
                                            </button>
                                        </div> */}
                                    </div>
                                    {/* <div>
                                        <button type='button' className='default-btn px-5 blue-bg border-0 w-100 mb-4 d-block d-lg-none'>
                                            Proceed with video submission
                                        </button>
                                    </div> */}
                                </React.Fragment>
                            ))}
                            <div className="pagination-container justify-content-center d-flex mb-4">
                                              <Pagination
                                                activePage={activePage + 1}
                                                itemsCountPerPage={5}
                                                totalItemsCount={categoryList?.pagination_info?.total_elements}
                                                pageRangeDisplayed={5}
                                                linkClass="custm_pagination"
                                                onChange={handlePageChange}
                                                itemClassFirst="page_first"
                                                itemClassPrev="page_prev"
                                                itemClassNext="page_next"
                                                itemClassLast="page_last"
                                              />
                                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Base>
    );
};

export default ScreeningCriteria;
